// Generated file : do not modify
export enum BillTypes
{
  NONE = 0,
  PAIES,
  SUBSCRIPTION,
  SERVICE,
  CREDIT_NOTE
};

import Owner from '@/extend/classes/Owner';
import { ListFilter } from '@/extend/classes/ListData';
import ListData from '@/extend/classes/ListData';
import { NotifDefTypes } from '@/generated/classes/NotifDef';
import { storeSession } from '@/generated/stores';
import { type AxiosResponse } from 'axios';
import {getRequestConfig} from "@/framework/base/helpers/HttpHelper.ts";

// Factures
export default class Bill  {
  // Identifiant unique
  public id: number;
  // Date de création
  public dateCreation: Date;
  // Prix TTC
  public price: number;
  // Chrono par type de facture
  public chrono: number;
  // Type
  public type: BillTypes;
  // Owner
  public owner: Owner;
  // Numéro TVA intracommunautaire
  public nii: number;
  // GUID de création du store
  public createId: string;
  // Commande non exécutée
  public failed: boolean;
  // Donnée pouvant être  modifiée
  public canUpdate: boolean;
  // Donnée pouvant être supprimée
  public canDelete: boolean;
  // Display des objets
  public display: string;
  // Type de notification
  public notifDefType: NotifDefTypes;
  // Type
  public ownerType: number;
  // Identifiant
  public ownerId: number;
  // Nom
  public ownerLabel: string;

  constructor() {
    this.id = 0;
    this.dateCreation = new Date(1901,1,1,0,0,0,0);
    this.price = 0;
    this.chrono = 0;
    this.type = BillTypes.NONE;
    this.owner = new Owner();
    this.nii = 0;
    this.createId = '';
    this.failed = false;
    this.canUpdate = true;
    this.canDelete = true;
    this.display = '';
    this.notifDefType = NotifDefTypes.NONE;
    this.ownerType = 0;
    this.ownerId = 0;
    this.ownerLabel = '';
  }

  public static fromJson (obj: Bill): Bill {
    const newBill: Bill = new Bill();
    newBill.id = obj.id;
    newBill.dateCreation = new Date(obj.dateCreation);
    newBill.price = obj.price;
    newBill.chrono = obj.chrono;
    newBill.type = obj.type;
    newBill.owner = JSON.parse(JSON.stringify(obj.owner));
    newBill.nii = obj.nii;
    newBill.createId = obj.createId;
    newBill.failed = obj.failed;
    newBill.canUpdate = obj.canUpdate;
    newBill.canDelete = obj.canDelete;
    newBill.display = obj.display;
    newBill.notifDefType = obj.notifDefType;
    newBill.ownerType = obj.ownerType;
    newBill.ownerId = obj.ownerId;
    newBill.ownerLabel = obj.ownerLabel;
    return newBill;
  }

  public toJsonBill (): string {
    const json = {
      dateCreation: this.dateCreation ? new Date (this.dateCreation).toString() : this.dateCreation,
      price: this.price,
      chrono: this.chrono,
      type: this.type,
      owner: this.owner,
      nii: this.nii,
      canUpdate: this.canUpdate,
      canDelete: this.canDelete,
      notifDefType: this.notifDefType,
    }
    return JSON.stringify(json);
  }

  public fromBill (obj: Bill): void {
    this.id = obj.id;
    this.dateCreation = new Date(obj.dateCreation);
    this.price = obj.price;
    this.chrono = obj.chrono;
    this.type = obj.type;
    this.owner = obj.owner;
    this.nii = obj.nii;
    this.createId = obj.createId;
    this.failed = obj.failed;
    this.canUpdate = obj.canUpdate;
    this.canDelete = obj.canDelete;
    this.display = obj.display;
    this.notifDefType = obj.notifDefType;
    this.ownerType = obj.ownerType;
    this.ownerId = obj.ownerId;
    this.ownerLabel = obj.ownerLabel;
  }

  public compareBill (value: Bill): boolean {
    return (this.toJsonBill() == value.toJsonBill());
  }

  public cloneBill (): Bill {
    return Bill.fromJson(this);
  }

  public static list (filter: ListFilter): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.post('api/bills/list', filter, getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              resolve(res.data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getForStore (id: number): Promise<ListData> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Bills/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              listData.reccords[0] = Bill.fromJson(listData.reccords[0] as Bill);
              resolve(listData);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static get (id: number): Promise<Bill> {
    return new Promise((resolve, reject) => {
      if (storeSession.httpCx != undefined) {
        return storeSession.httpCx.get('api/Bills/' + id.toString(), getRequestConfig())
          .then((res: AxiosResponse) => {
            if (res.status == 200) {
              const listData = res.data as ListData;
              const data = Bill.fromJson(listData.reccords[0] as Bill);
              resolve(data);
            } else {
              reject(res.data);
            }
          }).catch(() => {
            reject(null);
          });
      }
    });
  }

  public static getDate(bills: Bill[]) {
    bills.forEach((item) => {
      item.dateCreation = item.dateCreation ? new Date(item.dateCreation) : item.dateCreation;
    })
  }
}
